<div class="flex-none h-16 flex items-center justify-between bg-primary">
    <div class="text-on-primary px-2">
        <div>Демо-стенд карты на Angular</div>
    </div>
    <header-controls></header-controls>
</div>
<!-- ::TODO:: isAdminMap=true это временное решение т.к. пока не понятно как это определять -->
<app-map [isAdminMap]="true" class="flex-auto"></app-map>
